import React, { FC } from "react";
import { Column } from "../../../../../types/column";
import { MdDelete } from "react-icons/md";
import "./delete-cell.scss";

type Row = {
  id: number;
  name: string;
  [key: string]: any;
};

interface Props {
  row: Row;
  column: Column;
  index: number | boolean;
  hover: number | boolean;
  handleDelete: (row: Row) => void;
}

const DeleteCell: FC<Props> = ({ row, column, index, hover, handleDelete }) => {
  return (
    <div>
      {hover === row.id && (
        <button className="delete-cell" onClick={handleDelete.bind(this, row)}>
          <MdDelete color="red" width={40} height={40} />
        </button>
      )}
    </div>
  );
};

export default DeleteCell;
